export default __webpack_public_path__ + "static/media/ico_link_support.20ba4559.svg";